import { Action } from '@ngrx/store';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';


export enum BpmnXmlActionTypes {
  FETCH_BPMN_XML = '[Bpmn Process] Fetch Bpmn Xml',
  UPDATE_BPMN_XML = '[Bpmn Process] Update Bpmn Xml',
  UPDATE_BPMM_DEPLOYMENT_IDENTIFIER = '[Bpmn Process] Update Bpmn Deployment Idenitifer',
  MARK_BPMN_XML_PARSING_COMPLETED = '[Bpmn Process] Mark Bpmn Xml Parsing Completed',
  MARK_BPMN_XML_PARSING_IN_PROGRESS = '[Bpmn Process] Mark Bpmn Xml Parsing In Progress',
}

export class FetchBpmnXmlAction implements Action {
  readonly type = BpmnXmlActionTypes.FETCH_BPMN_XML;
  constructor(public payload: { bpmnDeploymentIdentifier: BpmnDeploymentIdentifier}) { }
}

export class UpdateBpmnXmlAction implements Action {
  readonly type = BpmnXmlActionTypes.UPDATE_BPMN_XML;
  constructor(public payload: { bpmnXml: string }) { }
}

export class UpdateBpmnDeploymentIdentifierAction implements Action {
  readonly type = BpmnXmlActionTypes.UPDATE_BPMM_DEPLOYMENT_IDENTIFIER;
  constructor(public payload: { bpmnDeploymentIdentifier: BpmnDeploymentIdentifier}) { }
}

export class MarkBpmnXmlParsingCompletedAction implements Action {
  readonly type = BpmnXmlActionTypes.MARK_BPMN_XML_PARSING_COMPLETED;
}

export class MarkBpmnXmlParsingInProgressAction implements Action {
  readonly type = BpmnXmlActionTypes.MARK_BPMN_XML_PARSING_IN_PROGRESS;
}

export type BpmnXmlActions = FetchBpmnXmlAction | UpdateBpmnXmlAction | UpdateBpmnDeploymentIdentifierAction | MarkBpmnXmlParsingCompletedAction | MarkBpmnXmlParsingInProgressAction;
